<template>
  <div>
    <!-- 认领弹窗 -->
    <a-modal
      :visible="visible"
      :confirm-loading="confirmLoading"
      destroyOnClose
      :maskClosable="false"
      :footer="null"
      :closable="false"
      :centered="true"
      :width="700"
    >
      <div class="content-claim">
        <div class="title">
          <a-icon @click="cancelfun" style="font-size: 16px; cursor: pointer" type="close" />
          <span>公客认领</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="addReceiveRecord">提交</span>
        </div>
        <textarea class="textarea" v-model="addRecord.receiveRemark" :maxlength="100" placeholder="请输入认领理由"></textarea>
        <div>
          <template v-if="isOpenReceiveAudit === 'Y'">
            <h3 style="font-weight: bold; margin-bottom: 30px">审核人</h3>
            <div class="reviewers-box">
              <div class="reviewers" v-if="nameObj.SHname" @click="addPicture">
                <!-- <a-icon v-show="index === isShowDelBtn" class="del-icon" type="minus-circle" @click="delBtn(index)" /> -->
                <img class="avatar" :src="nameObj.imgurl" />
                <span style="font-weight: bold; color: black; margin-top: 10px">
                  {{ nameObj.SHname && nameObj.SHname.length > 7 ? nameObj.SHname.substr(0, 7) + '...' : nameObj.SHname }}
                </span>
              </div>
              <div class="add-reviewers" v-else @click="addPicture">
                <a-icon style="color: var(--ThemeColor)" type="plus" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </a-modal>
    <!--弹窗-审核人添加-->
    <a-modal v-model="Reviewer" :centered="true" :closable="false" :footer="null" :maskClosable="false" width="500px">
      <div class="reviewer-title">
        <div class="title">
          <a-icon @click="ReviewerFn" style="font-size: 16px; cursor: pointer" type="close" />
          <span>选择审核人</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="Reviewerfun">确认</span>
        </div>

        <div class="choose-box">
          <a-select class="one" placeholder="成员" v-model="deptId" @change="handleChange">
            <!-- <a-select class="one" placeholder="成员" v-model="ryfrom.Claimketemp" @change="handleChange"> -->
            <!-- <a-select-option
              :value="item.leaderId"
              v-for="item in userList"
              :key="item.deptId+'_'+item.leaderId"
            >{{ item.deptName }}
            </a-select-option> -->
            <a-select-option :value="item.deptId" v-for="item in userList" :key="item.deptId + '_' + item.leaderId">
              <!-- {{ item.deptId }} -->
              {{ item.deptName }}
            </a-select-option>
          </a-select>
          <span class="one" style="margin-left: 20px">审核人：{{ leaderId | filterlist(userList) }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import houseApi from '@/api/system/houses/house.js';
import touristApi from '@/api/system/tourist/tourist.js';

export default {
  props: {
    isOpenReceiveAudit: {
      type: String,
      require: true,
      default: ''
    },
    visible: {
      type: Boolean,
      require: true
    },
    receiveType: {
      type: String,
      default: '1' // 1房2客
    },
    resourceId: {
      type: Number,
      require: true
    },
    rentSaleType: {
      type: String,
      default: '' // 1租2售
    }
  },
  data() {
    return {
      imgUrl: require('@/assets/home-imgs/头像.svg'),
      // 认领
      confirmLoading: false,

      nameObj: {},
      // 添加审核人
      Reviewer: false,
      isShowDelBtn: 111,

      deptId: undefined,
      ryfrom: {
        Claimke: undefined,
        Claimketemp: undefined // -userId
      },
      // 认领-请求参数
      addRecord: {
        auditIds: '', // 审核人ids
        receiveRemark: '', // 认领理由
        receiveType: this.receiveType, // 认领类型
        resourceId: this.resourceId, // 来源id
        rentSaleType: this.rentSaleType // 租售类型rent_sale_type  1租2售
      },
      // 部门人员
      dept: [],
      userList: [],
      leaderId: ''
    };
  },

  methods: {
    handleChange(val) {
      if (!val) {
        this.$message.warning('该部门暂无相关审核人');
        return;
      }
      const deptArr = this.userList.filter((user) => {
        return user.deptId.toString() === val.toString();
      });
      if (deptArr && deptArr.length > 0) {
        this.leaderId = deptArr && deptArr.length > 0 ? deptArr[0].leaderId : undefined;
        this.getLeaderAvater(deptArr[0].leaderId); // 获取头像
        this.ryfrom.Claimketemp = deptArr[0].leaderId;
      }
    },
    // 新增认领记录
    async addReceiveRecord() {
      // this.addRecord.auditIds = this.RLSHlist.map((v) => {
      //   return v.id
      // }).toString()
      const auditIds = this.nameObj.id;
      if (this.isOpenReceiveAudit === 'Y' && !(auditIds && typeof auditIds !== 'undefined' && auditIds !== '')) {
        this.$message.error('认领开启了审批，请选择审批人', 3);
        return;
      }
      this.addRecord.auditIds = auditIds ? auditIds.toString() : '';
      const res = await houseApi.addreceiveRecord({
        ...this.addRecord,
        version: 'v2'
      });
      if (res.code === 200) {
        this.$message.success('认领操作成功');
        this.cancelfun();
      }
    },
    // 关闭弹窗-清空数据
    cancelfun() {
      // this.uniqueArry = []
      // this.RLSHlist = []
      this.nameObj = {};
      this.addRecord.receiveRemark = '';
      this.addRecord.auditIds = '';
      this.$emit('closeTK');
      // this.$parent.getRelaInfoListFn()
    },

    // 获取审核人列表
    getDeptList() {
      touristApi.querySuperior().then((res) => {
        if (res.code === 200) {
          this.userList = res.data;
        }
      });
    },

    // 点击添加审核人-弹窗
    addPicture() {
      this.getDeptList();
      this.Reviewer = true;
    },
    // 数组去重
    // unique(arr) {
    //   const res = new Map()
    //   return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    // },

    // 审核人弹窗-确认
    Reviewerfun() {
      if (!this.ryfrom.Claimketemp) {
        this.$message.warning('您还未选择');
        return;
      }
      const nameindex = this.userList.findIndex((item) => {
        // console.log(item.leaderId, this.ryfrom.Claimketemp, item.leaderId == this.ryfrom.Claimketemp)
        return item.leaderId == this.ryfrom.Claimketemp;
      });
      (this.nameObj.id = this.userList[nameindex].leaderId), (this.nameObj.SHname = this.userList[nameindex].leader), this.ReviewerFn();
    },

    // 根据leaderId获取头像
    async getLeaderAvater(leaderId) {
      const res = await touristApi.getAvater(leaderId);
      if (res.code === 200) {
        this.nameObj.imgurl = res.data.avatar ? res.data.avatar : this.imgUrl;
      }
    },

    ReviewerFn() {
      this.ryfrom.Claimketemp = undefined;
      this.deptId = undefined;
      this.leaderId = '';
      this.Reviewer = false;
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
//认领 弹窗
.content-claim {
  height: auto;
  // height: 400px;
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .textarea {
    margin-top: 20px;
    width: 100%;
    height: 160px;
    outline: none;
    border-radius: 10px;
    border-color: #f1f2f3;
    padding: 10px;
    margin-bottom: 40px;
    resize: none;
    overflow: hidden;
  }
  .reviewers-box {
    margin-top: 10px;
    display: flex;
    margin-left: 10px;
    .reviewers {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      position: relative;
      .del-icon {
        position: absolute;
        top: 0;
        right: -10px;
        color: red;
        cursor: pointer;
      }
      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .add-reviewers {
      width: 60px;
      height: 60px;
      border: 1px dashed #9fa3ca;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}
.reviewer-title {
  height: 200px;
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .choose-box {
    margin-top: 20px;
    .one {
      width: 120px;
    }
  }
}
</style>
